import { Component, OnInit } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";
import { TimeZoneUtils } from "../utils/timezone.utils";

@Component({
  selector: "app-audit-users",
  templateUrl: "./audit-users.component.html",
  styleUrls: ["./audit-users.component.css"],
})
export class AuditUsersComponent implements OnInit {
  constructor(private _restService: RestService, private router: Router) {}

  isSuccess: boolean = false;
  isFailure: boolean = false;
  isLoading: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  actualArray: any = [];
  filterArray: any = [];

  isEvent: boolean = false;
  isUser: boolean = false;
  isCreated: boolean = false;
  isPath: boolean = false;
  isSystemName: boolean = false;
  isEnvironment: boolean = false;

  pageSize: any = 0;
  boxSize: any = 0;
  minValue: any = 0;
  maxValue: any = 0;
  prevValue: any = 0;
  totalJobsCount: number = 0;
  paginationLength: number = 0;

  options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: false,
    headers: ["Event Name", "User", "Created Date"],
    showTitle: false,
    useBom: false,
    removeNewLines: true,
    keys: ["eventName", "user", "dateFormatted"],
  };

  ngOnInit() {
    var sm,js;
    (this.isLoading = true),
      this._restService
        .getUserLogs()
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("User log", f.response),
            (this.actualArray = f.response),
            this.actualArray.forEach(m => m.createdDate = TimeZoneUtils.timezoneConvert(m.createdDate) ),
            (this.totalJobsCount = parseFloat(f.response.length) / 10),
            this.actualArray.map((f: any) =>
              f.hasOwnProperty("userEvent")
                ? f.userEvent === 1
                  ? (f.eventName = "User login")
                  : f.userEvent === 2
                  ? (f.eventName = "User logout")
                  : ""
                : f.hasOwnProperty("maintenanceEvent")
                ? f.maintenanceEvent === 1
                  ? (f.eventName = "Maintenance created")
                  : f.maintenanceEvent === 2
                  ? (f.eventName = "Maintenance series created")
                  : f.maintenanceEvent === 3
                  ? (f.eventName = "Maintenance occurrence deleted")
                  : f.maintenanceEvent === 4
                  ? (f.eventName = "Maintenance series deleted")
                  : f.maintenanceEvent === 5
                  ? (f.eventName = "Maintenance occurrence edited")
                  : f.maintenanceEvent === 6
                  ? (f.eventName = "Maintenance series edited")
                  : ""
                : f.hasOwnProperty("scheduleEvent")
                ? f.scheduleEvent === 1
                  ? (f.eventName = "Schedule Created")
                  : f.scheduleEvent === 2
                  ? (f.eventName = "Series created")
                  : f.scheduleEvent === 3
                  ? (f.eventName = "Schedule delete")
                  : f.scheduleEvent === 4
                  ? (f.eventName = "Series delete")
                  : f.scheduleEvent === 5
                  ? (f.eventName = "Occurrence edited")
                  : f.scheduleEvent === 6
                  ? (f.eventName = "Edited occurrence inside series")
                  : ""
                : ""
            ),
            this.actualArray.map(
              (f: any) =>
              (f.user = f.FirstName && f.LastName ? 
                f.FirstName.toString() + " " + f.LastName.toString() : '')
            ),
            this.actualArray.map(
              (f: any) =>
                (f.dateFormatted = new Date(f.createdDate).toLocaleString())
            ),
            this.actualArray.map(
              (f: any, index: any) => (
                (f.isExpand = false),
                (f.id = index + 1),
                (f.date = new Date(f.createdDate).toString())
              )
            ),
            (this.paginationLength =
              this.totalJobsCount % 1 === 0
                ? Math.round(this.totalJobsCount)
                : Math.round(this.totalJobsCount) + 1),
            this.loopingPagination(f.response.length),
            this.actualArray.map((f: any, index: any) =>
              index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
            ),
            (this.isLoading = false)
          )
        );
  }

  loopingPagination(l: any) {
    this.minValue = 1;
    this.maxValue = l > 10 ? 10 : l;
    this.pageSize = l;
    this.prevValue = 0;
    console.log("pageSize", this.pageSize);
  }

  nextpage(c: any, type: any) {
    let pageSize = this.pageSize;
    this.minValue = c + 1;
    this.maxValue = c + 10 >= pageSize ? pageSize : c + 10;
    this.prevValue = c;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.pageSize);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? JSON.stringify(this.filterArray.push(f))
            : ""
        ))
      : "";
  }

  prevpage(p: any, type: any) {
    this.minValue = p - 10 + 1;
    this.maxValue = p;
    this.prevValue = p - 10;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.prevValue);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? JSON.stringify(this.filterArray.push(f))
            : ""
        ))
      : "";
  }

  expand(id: any) {
    this.actualArray.map((f: any) =>
      f.id === id
        ? f.isExpand === true
          ? (f.isExpand = false)
          : (f.isExpand = true)
        : (f.isExpand = false)
    );
  }

  event() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isEvent === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.eventName.localeCompare(b.eventName);
      });
      this.isEvent = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.eventName.localeCompare(a.eventName);
      });
      this.isEvent = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    }
  }

  user() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isUser === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.FirstName.localeCompare(b.FirstName);
      });
      this.isUser = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.FirstName.localeCompare(a.FirstName);
      });
      this.isUser = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    }
  }

  created() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isCreated === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.date.localeCompare(b.date);
      });
      this.isCreated = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.date.localeCompare(a.date);
      });
      this.isCreated = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    }
  }

  searchKeyword(e: any) {
    if (e.target.value === "") {
      (this.filterArray = []),
        (this.totalJobsCount = parseFloat(this.actualArray.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.actualArray.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    } else {
      let v = e.target.value.toLowerCase();
      let temp: any = [];
      this.filterArray = [];

      this.actualArray.map((f: any) =>
        f.eventName.toLowerCase().includes(v) ||
        f.date.toLowerCase().includes(v) ||
        f.user.toLowerCase().includes(v)
          ? temp.push(f)
          : ""
      );

      (this.totalJobsCount =
        this.actualArray.length > 10
          ? parseFloat(this.actualArray.length) / 10
          : 1),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(temp.length),
        temp.map((f: any, index: any) =>
          index + 1 <= 10 ? JSON.stringify(this.filterArray.push(f)) : ""
        );
    }
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }
}
